module.exports = __webpack_public_path__ + "img/Network_and_Technology.2818cb3f.jpg";